import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding-block: 0;

  --gap: 2rem;
  --line-offset: calc(var(--gap) / 2);
  --line-thickness: 1px;
  --line-color: #88888826;
  --line-length: 100%;

  display: grid;
  overflow: hidden;
  gap: var(--gap);

  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media only screen and (max-width: 431px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const MiddleContentWrapper = styled.div`
  padding-block: 0;
`;

export const InnerContentWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding-bottom: 0;
  }
`;

export const FooterActionWrapper = styled.div`
  margin-top: 1.875rem;

  @media only screen and (max-width: 768px) {
    margin: 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const HeaderWrapper = styled.div`
  position: relative;
  z-index: 1;
  padding-top: 2rem;
  padding-bottom: 2rem;

  @media only screen and (max-width: 768px) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  @media only screen and (max-width: 430px) {
    padding-bottom: 0.5rem;
  }
`;

export const MbPaginationWrapper = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;

export const DesktopPaginationWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
